import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationSuggestBlogPostBuilderSectionArgs,
  BackendSuggestBlogPostBuilderContent,
} from 'src/types/backend';

const MUTATION = gql`
  mutation SuggestBlogPostBuilderIntroSection(
    $projectId: ID!
    $assetType: AssetTypeEnum!
    $continueMode: ContinueModeEnum
    $recomposeMode: RecomposeModeEnum
    $generationLength: String!
    $keywords: [String!]
    $instruction: Instruction
    $tovInput: TovInput
    $markedSegment: MarkedSegment
    $debugAcPrompt: String
    $freestyleToolAllInstructionsData: JSON
    $url: String
    $urlExtractions: [UrlExtractionInput!]
    $isParagraphMode: Boolean
  ) {
    suggestBlogPostBuilderIntroSection(
      projectId: $projectId
      assetType: $assetType
      continueMode: $continueMode
      recomposeMode: $recomposeMode
      generationLength: $generationLength
      keywords: $keywords
      instruction: $instruction
      tovInput: $tovInput
      markedSegment: $markedSegment
      debugAcPrompt: $debugAcPrompt
      freestyleToolAllInstructionsData: $freestyleToolAllInstructionsData
      url: $url
      urlExtractions: $urlExtractions
      isParagraphMode: $isParagraphMode
    ) {
      copyText
      keywordsUsage
    }
  }
`;

// NOTE: the "suggestBlogPostBuilderIntroSection" mutation is not present in the backend
// GraphQL schema, so its variables borrow the sibling "Section" mutation's args (same shape,
// minus "sectionId") and it returns the shared SuggestBlogPostBuilderContent type.
// TODO: check if we can remove this module
type Variables = Omit<
  BackendMutationSuggestBlogPostBuilderSectionArgs,
  'sectionId' | 'promptDocumentId' | 'promptImageId'
>;
type Result = BackendSuggestBlogPostBuilderContent;

export const suggestBlogPostBuilderIntroSection = async (
  { freestyleToolAllInstructionsData, ...rest }: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...rest,
      freestyleToolAllInstructionsData: stringifyIfPresent(freestyleToolAllInstructionsData),
    },
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  const parsedRes = getSingleProp<Result>(response.data);
  return {
    ...parsedRes,
    keywordsUsage: parsedRes?.keywordsUsage ? JSON.parse(parsedRes.keywordsUsage as string) : null,
  };
};
